import { detectPreferredLocale, localePath } from "../i18n";
import { getSavedLocale } from "./storage";

const locale = getSavedLocale() ?? detectPreferredLocale(navigator.languages);
location.replace(localePath(locale));
